import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SmallBodyText, TextField } from '../../../../../ui-toolkit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';

export const LoanNumber: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'Loan Number'}
      tab={`summary`}
      field={`loan_number`}
      onUpdate={(_, value) => onPatchOrderInformation({ loanId: value ?? null })}
      data-test-id={'loan-number'}
      order={order}
      editControl={TextField}
      editProps={{ placeholder: 'abcdefg123456' }}
    >
      {order.transaction.loan_number ?? <SmallBodyText intent={`faded`}>-</SmallBodyText>}
    </SummaryItemWithEdit>
  );
};
